/* eslint-disable react/no-did-update-set-state */
/* eslint-disable class-methods-use-this */
import React from 'react';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Button, Input, Select, Switch, Skeleton, Modal, Alert, Icon } from 'antd';
import RichTextEditor from '../../Editor/RichTextEditor';
import './BotConfig.scss';
import eventTypes from '../../../Analytics/EventTypes';
import message from './ChatbotMessages';
import placeholder from '../../Placeholders/PlaceholdersMessages';
import QuestionItemContainer from '../QuestionItemContainer/QuestionItemContainer';
import { BotQuestionsMixin } from '../BaseTemplateForm/BotQuestionsMixin';

const { Option } = Select;
const { TextArea } = Input;

class BotConfig extends React.Component {
  constructor(props) {
    super(props);
    const initialState = BotQuestionsMixin.initializeBotQuestions(props.questions || []);
    this.state = {
      selectedTemplateId: undefined,
      propQuestions: _.cloneDeep(props.questions) || [],
      botResponses: {},
      showModal: false,
      selectedTab: 'botQuestions',
      dragQuestionId: -1,
      ...initialState,
    };
    this.getBotResponseItem = this.getBotResponseItem.bind(this);
    this.getBotQuestionsTab = this.getBotQuestionsTab.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.removeQuestion = this.removeQuestion.bind(this);
    this.onResponseChange = this.onResponseChange.bind(this);
    this.prepareQuestions = this.prepareQuestions.bind(this);
    this.onTemplateSelect = this.onTemplateSelect.bind(this);
    this.onSaveForm = this.onSaveForm.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onUpdateJobDescription = this.onUpdateJobDescription.bind(this);
    this.getBotConfigHeader = this.getBotConfigHeader.bind(this);
    this.onQuestionFieldChange = this.onQuestionFieldChange.bind(this);
    this.lastQuestionRef = React.createRef();
    this.forRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    const newState = _.clone(state);

    if (Object.keys(state.botResponses).length === 0 && Object.keys(_.get(props, ['answers'], {})).length !== 0) {
      _.set(newState, ['botResponses'], props.answers);
    }

    if (state.isBotEnabled === undefined && props.isBotEnabled !== undefined) {
      _.set(newState, ['isBotEnabled'], props.isBotEnabled);
    }

    if (state.goodbyeMessage === undefined && props.goodbyeMessage !== undefined) {
      _.set(newState, ['goodbyeMessage'], props.goodbyeMessage);
    }

    return newState;
  }

  componentDidUpdate(prevProps) {
    const { questions, answers } = this.props;
    if (!_.isEqual(prevProps.questions, questions)) {
      const initialState = BotQuestionsMixin.initializeBotQuestions(questions);
      this.setState({
        propQuestions: _.cloneDeep(questions),
        showFollowupQuestions: initialState.showFollowupQuestions,
      });
    }
    if (_.get(prevProps, ['answers']) && answers && prevProps.answers !== answers) {
      this.setState({
        botResponses: answers,
      });
    }
  }

  onResponseChange(id, response) {
    const { botResponses } = this.state;
    this.setState({
      botResponses: {
        ...botResponses,
        [id]: response,
      },
    });
  }

  onUpdateJobDescription({ htmlContent }) {
    this.onResponseChange('JobDescription', htmlContent);
  }

  onTemplateSelect(value) {
    const { getTemplateQuestions, aryabotTemplatesById } = this.props;
    this.setState({ selectedTemplateId: value });
    if (value) {
      if (_.get(aryabotTemplatesById, [value, 'Questions'], false)) {
        this.addTemplateQuestions(aryabotTemplatesById[value].Questions);
      } else {
        getTemplateQuestions(value, questions => this.addTemplateQuestions(questions));
      }
    }
  }

  onQuestionFieldChange = (field, order, value) => {
    const { propQuestions, categoryErrors, questionErrors } = this.state;
    const updatedQuestions = BotQuestionsMixin.onQuestionFieldChange(propQuestions, field, order, value);
    const clonedCategoryErrors = { ...categoryErrors };
    const clonedQuestionErrors = { ...questionErrors };
    if (value?.trim() && field === 'CategoryName') {
      delete clonedCategoryErrors[order];
    }
    if (value?.trim() && field === 'Question') {
      delete clonedQuestionErrors[order];
    }
    if (!value?.trim() && field === 'CategoryName') {
      clonedCategoryErrors[order] = true;
    }
    if (!value?.trim() && field === 'Question') {
      clonedQuestionErrors[order] = true;
    }
    this.setState({
      propQuestions: updatedQuestions,
      categoryErrors: clonedCategoryErrors,
      questionErrors: clonedQuestionErrors,
    });
  };

  onCategoryChange = (order, value) => {
    const { propQuestions, showFollowupQuestions } = this.state;
    const { updatedQuestions, removedOrders } = BotQuestionsMixin.removeChildQuestions(
      BotQuestionsMixin.onCategoryChange(propQuestions, order, value),
      order
    );
    const { updatedShowFollowupQuestions } = BotQuestionsMixin.updateOrderForRemove(
      { showFollowupQuestions },
      removedOrders,
      {}
    );
    updatedShowFollowupQuestions[order] = false;
    this.setState(
      {
        propQuestions: updatedQuestions,
        showFollowupQuestions: updatedShowFollowupQuestions,
      },
      this.validateForm
    );
  };

  onSaveForm() {
    const { onSave, isTextAgentConfigEditEnabled } = this.props;
    const { botResponses, isBotEnabled, goodbyeMessage } = this.state;
    if (isTextAgentConfigEditEnabled === false) {
      return;
    }
    if (!this.validateForm()) {
      const { ApplicationProcess, JobViewUrl, ...answers } = botResponses;
      onSave(this.prepareQuestions(), answers, isBotEnabled, goodbyeMessage);
    } else {
      this.expandAllFollowupQuestions();
    }
  }

  updateDragQuestionId = (type, dragQuestionId) => {
    this.setState({ dragQuestionId });
  };

  getBotResponseItem(id, question, isDisabled) {
    const { botResponses } = this.state;
    const { intl } = this.props;

    return (
      <div className="response-item" key={id}>
        <div className="question">{question}</div>
        {id === 'JobDescription' ? (
          <RichTextEditor
            editorContent={{ htmlContent: botResponses[id] }}
            onChange={this.onUpdateJobDescription}
            showToolbar
          />
        ) : (
          <TextArea
            rows={1}
            size="small"
            placeholder={intl.formatMessage({ ...placeholder.writeYourAnswerHereLabel })}
            value={botResponses[id]}
            onChange={event => {
              this.onResponseChange(id, event.target.value);
            }}
            className="answer"
            autosize={{ minRows: 1, maxRows: 6 }}
            disabled={isDisabled}
          />
        )}
      </div>
    );
  }

  getBotResponsesTab() {
    const { frequentQuestions, frequentQuestionGroups, intl, isTextAgentConfigEditEnabled } = this.props;
    const { goodbyeMessage } = this.state;
    return (
      <div className="bot-responses">
        {Object.keys(frequentQuestionGroups).map(questionGroup => {
          return (
            <div className="question-group" key={questionGroup}>
              {questionGroup}
              <div className="questions-list">
                {frequentQuestionGroups[questionGroup].map(questionCode => {
                  return this.getBotResponseItem(
                    questionCode,
                    _.get(frequentQuestions, [questionCode, 'Question'], ''),
                    _.get(frequentQuestions, [questionCode, 'IsDisabled'], false)
                  );
                })}
              </div>
            </div>
          );
        })}
        <div className="question-group" key="goodbyeMessage">
          <FormattedMessage {...message.goodbyeMessageLabel} />
          <div className="questions-list">
            <div className="response-item">
              <TextArea
                rows={1}
                size="small"
                placeholder={intl.formatMessage({ ...message.goodbyeMessagePlaceholder })}
                value={goodbyeMessage}
                onChange={event => {
                  this.setState({ goodbyeMessage: event.target.value });
                }}
                className="answer"
                autosize={{ minRows: 1, maxRows: 4 }}
                disabled={isTextAgentConfigEditEnabled === false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleGenerateQuestions = () => {
    const { jobDescription, generateQuestions, BotContextId } = this.props;
    generateQuestions(BotContextId, jobDescription);
    this.setState({
      selectedTemplateId: undefined,
      showModal: false,
    });
  };

  moveQuestions = (dragIndex, hoverIndex) => {
    const { propQuestions } = this.state;
    const { orderUpdateMapper } = BotQuestionsMixin.moveQuestions(propQuestions, dragIndex, hoverIndex);
    if (Object.keys(orderUpdateMapper).length > 0) {
      this.updateOrder(orderUpdateMapper);
    }
  };

  collapseFollowupQuestions = (questionOrder, status) => {
    const { showFollowupQuestions } = this.state;
    const updatedStatus = BotQuestionsMixin.collapseFollowupQuestions(showFollowupQuestions, questionOrder, status);
    this.setState({
      showFollowupQuestions: updatedStatus,
    });
  };

  collapseAllFollowupQuestions = () => {
    const { showFollowupQuestions } = this.state;
    const updatedStatus = BotQuestionsMixin.collapseAllFollowupQuestions(showFollowupQuestions, false);
    this.setState({
      showFollowupQuestions: updatedStatus,
    });
  };

  updateCollapseOfQuestions = showFollowupQuestions => {
    this.setState({
      showFollowupQuestions,
    });
  };

  expandAllFollowupQuestions = () => {
    const { showFollowupQuestions } = this.state;
    const updatedStatus = BotQuestionsMixin.collapseAllFollowupQuestions(showFollowupQuestions, true);
    this.setState({
      showFollowupQuestions: updatedStatus,
    });
  };

  updateOrder = orderUpdateMapper => {
    const { propQuestions } = this.state;
    const { updatedQuestions, showFollowupQuestions } = BotQuestionsMixin.updateOrder(propQuestions, orderUpdateMapper);
    this.setState(
      {
        propQuestions: updatedQuestions,
        showFollowupQuestions,
      },
      this.validateForm
    );
  };

  getBotQuestionsTab() {
    const { readOnly, subTitle, getJobQuestionApiStatus } = this.props;
    const { showModal, propQuestions, categoryErrors, questionErrors, showFollowupQuestions, dragQuestionId } =
      this.state;
    const questionItems = BotQuestionsMixin.renderQuestions(propQuestions, {
      categoryErrors,
      questionErrors,
      showFollowupQuestions,
      removeQuestion: this.removeQuestion,
      onCategoryChange: this.onCategoryChange,
      addQuestion: this.addQuestion,
      onQuestionFieldChange: this.onQuestionFieldChange,
      onDragQuestion: this.moveQuestions,
      collapseFollowupQuestions: this.collapseFollowupQuestions,
      readOnly,
      QuestionItemComponent: QuestionItemContainer,
      updateDragQuestionId: this.updateDragQuestionId,
      dragQuestionId,
      updateCollapseOfQuestions: this.updateCollapseOfQuestions,
    });

    return (
      <div className="bot-screening-questions">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {subTitle || <FormattedMessage {...message.aryabotQuestionPrompt} />}&nbsp;&nbsp;
          <Button
            onClick={this.collapseAllFollowupQuestions}
            shape="round"
            disabled={readOnly || !propQuestions?.length}
          >
            <FormattedMessage {...message.collapseAll} />
          </Button>
        </div>
        {showModal && (
          <Modal
            title="Generate/Regenerate Questions"
            visible={showModal}
            onOk={this.handleGenerateQuestions}
            onCancel={() => this.setState({ showModal: false })}
            okText="Yes"
            zIndex={2001}
          >
            Manually added questions will be removed. Do you want to proceed?
          </Modal>
        )}
        <div className="questions" ref={this.lastQuestionRef}>
          <Skeleton active loading={getJobQuestionApiStatus === 'INPROGRESS'} paragraph={{ rows: 3 }}>
            {questionItems}
          </Skeleton>
        </div>
      </div>
    );
  }

  addTemplateQuestions(questions) {
    const { propQuestions, showFollowupQuestions } = this.state;
    const updatedStatus = _.mapValues(showFollowupQuestions, () => false);
    const n = propQuestions.filter(q => !q.Order.includes('.')).length;
    const updatedQuestions = questions.map(q => {
      if (!q.Order.includes('.')) {
        const order = String(Number(q.Order) + n);
        updatedStatus[order] = false;
        return { ...q, Order: order };
      }
      const parts = q.Order.split('.');
      parts[0] = String(Number(parts[0]) + n);
      const order = parts.join('.');
      updatedStatus[order] = false;
      return { ...q, Order: order };
    });
    this.setState({
      propQuestions: [...propQuestions, ...updatedQuestions],
      showFollowupQuestions: updatedStatus,
    });
  }

  addQuestion(order) {
    const { propQuestions } = this.state;
    const { isPaidJobServiceEnabled } = this.props;
    const updatedQuestions = BotQuestionsMixin.addQuestion.call(this, propQuestions, order, isPaidJobServiceEnabled);
    this.setState({
      propQuestions: updatedQuestions,
    });
  }

  removeQuestion(order) {
    const { propQuestions, showFollowupQuestions } = this.state;
    const { updatedQuestions, removedOrders, orderUpdateMapper } = BotQuestionsMixin.removeQuestion(
      propQuestions,
      order
    );
    const { updatedShowFollowupQuestions } = BotQuestionsMixin.updateOrderForRemove(
      { showFollowupQuestions },
      removedOrders,
      orderUpdateMapper
    );
    this.setState(
      {
        propQuestions: updatedQuestions,
        showFollowupQuestions: updatedShowFollowupQuestions,
      },
      this.validateForm
    );
  }

  prepareQuestions() {
    const { propQuestions } = this.state;
    return propQuestions
      .filter(question => question.Question && question.CategoryName !== 'UNDEFINED')
      .map(question => {
        return {
          Question: question.Question,
          ExpectedAnswer: question.ExpectedAnswer,
          CategoryName: question.CategoryName,
          Order: question.Order,
          CreatedBy: question.CreatedBy,
          CreatedTime: question.CreatedTime,
          Id: question.Id,
        };
      });
  }

  getBotConfigHeader() {
    const { aryabotTemplatesById, currentAryabotTemplateIds, intl, hideSelectTemplate } = this.props;
    const { selectedTab, selectedTemplateId } = this.state;
    const handleTabChange = tab => {
      this.setState({ selectedTab: tab });
    };

    const tabs = [
      { key: 'botQuestions', label: message.aryabotQuestionsTab },
      { key: 'botResponses', label: message.aryabotResponses },
    ];

    const showSelectTemplate = !hideSelectTemplate && selectedTab === 'botQuestions';

    return (
      <div className="bot-config-header">
        <div className="tabs-button-container">
          {tabs.map(({ key, label }) => (
            <div
              key={key}
              className={`tabs-button ${selectedTab === key ? 'selected' : ''}`}
              onClick={() => handleTabChange(key)}
              role="button"
              tabIndex={0}
            >
              <FormattedMessage {...label} />
            </div>
          ))}
        </div>
        {showSelectTemplate && (
          <Select
            allowClear
            dropdownClassName="select-aryabot-template"
            className="select-template"
            value={selectedTemplateId}
            placeholder={intl.formatMessage({ ...placeholder.pleaseSelectATemplateLabel })}
            onChange={value => this.onTemplateSelect(value)}
            showSearch
            optionFilterProp="title"
            getPopupContainer={() => this.forRef.current}
          >
            {currentAryabotTemplateIds.map(templateId => {
              const aryabotTemplate = aryabotTemplatesById[templateId];
              return (
                <Option key={aryabotTemplate.Id} title={aryabotTemplate.Name}>
                  {aryabotTemplate.Name}
                </Option>
              );
            })}
          </Select>
        )}
      </div>
    );
  }

  validateForm() {
    const { propQuestions } = this.state;
    const { hasErrors, categoryErrors, questionErrors } = BotQuestionsMixin.validateForm(propQuestions);
    this.setState({
      categoryErrors,
      questionErrors,
    });
    return hasErrors;
  }

  onAddNewQuestionClick = () => {
    const { propQuestions } = this.state;
    const currentLastQuestionOrder = BotQuestionsMixin.getCurrentLastQuestionOrder(propQuestions);
    this.addQuestion(`${Number(currentLastQuestionOrder) + 1}`);
    setTimeout(() => {
      if (this.lastQuestionRef.current) {
        const modalBody = this.lastQuestionRef.current.closest('.ant-modal-body');
        if (modalBody) {
          modalBody.scrollTo({ top: modalBody.scrollHeight, behavior: 'smooth' });
        }
      }
    }, 10);
  };

  render() {
    const { saveLoading, showBotQuestionsReviewMessage, updateReviewMessageVisibility, readOnly, isTextAgentConfigEditEnabled } = this.props;
    const { isBotEnabled, selectedTab } = this.state;

    return (
      <div>
        {this.getBotConfigHeader()}
        {selectedTab === 'botQuestions' ? (
          <div style={{ position: 'relative' }} ref={this.forRef}>
            {showBotQuestionsReviewMessage ? (
              <Alert
                closable
                showIcon
                type="info"
                className="review-questions-alert"
                message={<FormattedMessage {...message.reviewQuestionsMessage} />}
                onClose={() => updateReviewMessageVisibility(false)}
              />
            ) : null}
            {this.getBotQuestionsTab()}
          </div>
        ) : (
          <>{this.getBotResponsesTab()}</>
        )}

        <div className="bot-config-footer">
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', height: '33px' }}>
            <div style={{ width: '160px', display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '80px', marginRight: '10px', whiteSpace: 'nowrap' }}>
                <FormattedMessage {...message.aryabotLabel} />
              </div>
              <Switch
                checked={isBotEnabled}
                checkedChildren={<FormattedMessage {...message.onText} />}
                unCheckedChildren={<FormattedMessage {...message.offText} />}
                onChange={checked => this.setState({ isBotEnabled: checked })}
              />
            </div>
            {!readOnly && (
              <button type="button" className="add-question-button" onClick={this.onAddNewQuestionClick}>
                <Icon type="plus-circle" theme="outlined" className="add-question-icon" style={{ fontSize: '16px' }} />
                <FormattedMessage {...message.addQuestionsButton} />
              </button>
            )}
          </div>
          <Button
            type="primary"
            onClick={this.onSaveForm}
            disabled={isTextAgentConfigEditEnabled === false}
            loading={saveLoading}
            sk-event-name={eventTypes.job.aryaBotConfig.saveAryaBotConfig}
          >
            <FormattedMessage {...message.saveButton} />
          </Button>
        </div>
      </div>
    );
  }
}

export default injectIntl(DragDropContext(HTML5Backend)(BotConfig));
export { BotConfig };
